<template>
  <div style="min-height: 100vh;background-color: #F6F6F6;" class="max">
    <div class="frame-content" style="position: relative;min-height: 100%;">
      <div style="width: 100%;padding-bottom: 70px">
        <HomeHeader></HomeHeader>
      </div>
      <div style="width: 1180px;min-height: 1530px; background-color: #F6F6F6;padding-bottom: 250px;margin: auto;">
        <div class="step_box">
          <div class="step_item">
            <div class="num active">
              <i class="iconfont icon-bianji" style="font-size: 10px"/>
            </div>
            <span style="color: #1e50f0">填写订单</span>
          </div>
          <i class="el-icon-arrow-right" />
          <div class="step_item">
            <div class="num">
              <i class="el-icon-check" style="font-size: 12px"/>
            </div>
            <span>确认订单</span>
          </div>
          <i class="el-icon-arrow-right" />
          <div class="step_item">
            <div class="num">
              <i class="iconfont icon-xinyongka" style="font-weight: normal;color: #8a9bb5"/>
            </div>
            <span>支付完成</span>
          </div>
        </div>
        <!-- row2 -->
        <el-row style="width: 1180px;margin: auto;">
          <!--      左边      -->
          <el-col :span="16">
            <div class="count_down_box">
              <i class="el-icon-timer" />
              <span>请在{{countdownMinute}}分{{countdownSecond}}秒内完成填写, 以免房间被订或者价格发生变化</span>
            </div>
            <!--   填写入住信息    -->
            <el-row class="info-panel"
              style="min-height: 300px;background-color: #FFFFFF;box-shadow: 2px 2px 5px #ECECEC;">
              <div class="panel-title" style="margin-top: 10px;">{{ $t('booking.Fill_in') }}</div>
              <!--         入离时间       -->
              <el-row
                style="margin-top: 35px;margin-left: 20px;padding-bottom: 10px;">
                <el-col :span="3">
                  <span style="font-size: 14px;color: #333333;">入离日期</span>
                </el-col>
                <el-col :span="19" style="margin-left: 10px;font-size: 14px">
                  <span style="color: #148cf5;">{{ checkRateReq.checkIn }}</span>
                  <span style="margin-left: 5px;">
                    {{ getDay(checkRateReq.checkIn) }}
                  </span>
                  <span style="margin: 0 10px;">{{ $t('booking.to') }}</span>
                  <span style="color: #148cf5;">{{ checkRateReq.checkOut }}</span>
                  <span style="margin-left: 5px;">
                    {{ getDay(checkRateReq.checkOut) }}
                  </span>
                  <span style="margin: 0 5px;">共<span
                      style="color: #10909B;">{{  rateInfo.rates ? rateInfo.rates.length : 0 }}</span>晚</span>
                </el-col>
              </el-row>
              <!--      贵司订单号          -->
              <el-row
                style="margin-top: 10px;display: flex;align-items: center;padding-bottom: 10px;margin-left: 20px;">
                <el-col :span="4"
                        style="font-size: 14px;display: flex;align-items: center;position: relative;margin-right: 10px;">
                  <span style="color: red;">*{{ $t('booking.Your_order_number') }}</span>
                  <el-popover placement="bottom" width="200" trigger="hover" style="position: absolute;right: -10px;">
                    <span slot="reference">
                      <img src="@/assets/img/iconOrderNo.png" height="16px;" width="16px;"
                           style="line-height: 16px;text-align: center;">
                    </span>
                    <div>
                      <div>
                        贵司订单号便于您管理自己的订单，不会发送给酒店，不能超过30个字符，仅支持字母、数字、"/"、"-"。
                      </div>
                    </div>
                  </el-popover>
                </el-col>
                <el-col :span="20" style="margin-left:12px;display: flex;column-gap: 5px;align-items: center">
                  <el-input style="width: 295px" class="clientReference" v-model="bookingForm.clientReference"
                            :placeholder="$t('booking.Your_order_number')" @input="inputChannelOrderNum">
                  </el-input>
                  <div style="font-size: 12px;color: #cecdcd;word-break: keep-all;" v-if="!existOrder">默认单号，可修改或使用自有单号</div>
                  <div style="font-size: 12px;color: red;word-break: keep-all;" v-else>已有相同的订单号，请重新输入</div>
                </el-col>
              </el-row>
              <div class="room_adults_box" style="padding:0 0 0 18px;display: flex;align-items: center;column-gap: 12px;margin-bottom: 15px">
                <div style="color: #333333;font-size: 14px;">
                  <span style="margin-right: 8px">房间数:</span>
                  <el-select v-model="checkRateReq.rooms" style="width: 245px" placeholder="房间数" @change="reCheckRate">
                    <el-option v-for="(item, index) in 4" :key="index" :label="item + '间'" :value="item"/>
                  </el-select>
                </div>
                <div style="color: #333333;font-size: 14px">
                  <span style="margin-right: 8px">成人数:</span>
                  <el-select v-model="checkRateReq.adults" style="width: 245px" placeholder="成人数" @change="reCheckRate">
                    <el-option v-for="(item, index) in 4" :key="index" :label="item + '成人'" :value="item"/>
                  </el-select>
                </div>
              </div>
              <div style="margin-bottom: 10px;margin-left: 15px">
                <span v-show="!checkRatePass" style="color: red;font-size: 12px;">无法为您提供当前条件下的房间数报价，请修改入住人或房间数</span>
              </div>
              <div class="guest_box" :style="checkRateReq.rooms > 1 ? 'background-color: #f5f7fa;padding: 15px 0' : ''" v-for="(g, i) in showRoomGuest" :key="i">
                <div style="padding: 0 15px;color: #000000;font-weight: 600;font-size: 14px" v-if="checkRateReq.rooms > 1">房间{{ i + 1 }}</div>
                <el-row v-for="(a, index) in checkRateReq.adults" :key="index" style="margin-top: 15px;">
                  <el-col :span="3" class="booking-form-title" v-show="index === 0 || g[index].show">
                  <span style="font-size: 14px;color: #333333">
                    <span v-if="index === 0" style="color: red">*</span>
                    {{ $t('booking.guest') }}{{ index + 1 }}
                  </span>

                  </el-col>
                  <el-col :span="$commonUtil.getRegionIdBySHotelId(checkRateReq.hotelId) ? 3 : 5"
                          v-show="index === 0 || g[index].show">
                    <el-input v-model.trim="g[index].lastName" class="lastName"
                              :placeholder="$commonUtil.getRegionIdBySHotelId(checkRateReq.hotelId) ? $t('booking.last_name') : '姓 拼音或英文'"></el-input>
                  </el-col>
                  <el-col :span="9" style="padding-left: 10px" v-show="index === 0 || g[index].show">
                    <el-input v-model.trim="g[index].firstName" class="firstName"
                              :placeholder="$commonUtil.getRegionIdBySHotelId(checkRateReq.hotelId) ? $t('booking.first_name') : '名 拼音或英文'"></el-input>
                  </el-col>
                  <el-col :span="4" style="line-height: 35px; padding-left: 10px;color: #adadad;font-size: 14px;cursor: pointer;">
                    <i class="el-icon-circle-plus-outline" @click="guestChange(g, true, g[index], index)"
                       v-show="showGuest(g, g[index], index, 1)"/>
                    <i class="el-icon-remove-outline" style="font-size: 16px" @click="guestChange(g, false, g[index], index)"
                       v-show="showGuest(g, g[index], index, 2)"/>
                  </el-col>
                </el-row>
              </div>
            </el-row>

            <!--     联系人信息      -->
            <el-row class="info-panel content_box" style="height: 230px;background-color: #FFFFFF;box-shadow: 2px 2px 5px #ECECEC;">
              <div class="panel-title" style="margin-top: 10px">{{ $t('booking.contact_information') }}</div>
              <el-row style="margin-top: 50px;display: flex;align-items: center;margin-left: 20px;">
                <el-col :span="3" style="font-size: 16px;">
                  <span style="color: red;font-size: 16px;">*</span>{{ $t('booking.name') }}
                </el-col>
                <el-col :span="14">
                  <el-input style="width: 100%" class="contactName" v-model="bookingForm.contactName"
                    :placeholder="$t('booking.name')"></el-input>
                </el-col>
                <el-col :span="6" style="line-height: 30px;padding-left: 20px;cursor: pointer;color: #999999;">
                  <div @click="isShowContactSelect = true">
                    <i class="iconfont icon-tongxunlu01-F" style="color: #1e50f0"></i>
                    <span style="color: #1e50f0;font-size: 16px;">{{ $t('booking.Select_contacts') }}</span>
                  </div>
                </el-col>
              </el-row>

              <el-row style="margin-top: 25px;display: flex;align-items: center;margin-left: 20px;">
                <el-col :span="3" style="font-size: 16px;">
                  <span style="color: red;font-size: 16px;">*</span>{{ $t('booking.phone_number') }}
                </el-col>
                <el-col :span="14">
                  <el-select v-model="bookingForm.contactPhoneRegion" filterable style="width: 28%" class="contactName">
                    <el-option v-for="item in phoneRegions" :key="item.id" :label="item.value" :value="item.value">
                      {{ item.name + ' ' + item.value }}
                    </el-option>
                  </el-select>
                  <el-input style="width: 70%;" v-model="bookingForm.contactPhone" class="contactName"
                    :placeholder="$t('booking.phone_number')"></el-input>
                </el-col>
              </el-row>
              <el-row style="margin-top: 25px;display: flex;align-items: center;margin-left: 20px;">
                <el-col :span="3" style="font-size: 16px;">
                  <span style="color: red;font-size: 16px;">*</span>{{ $t('booking.email') }}
                </el-col>
                <el-col :span="14" style="display: flex;">
                  <el-input v-model="bookingForm.contactEmail" class="contactName"
                    :placeholder="$t('booking.send_email')"></el-input>
                  <!-- <div style="margin-top: 15px; margin-left: 24px; color: #999999;font-size: 16px;">
                      {{ $t('booking.send_email') }}
                    </div> -->
                </el-col>
              </el-row>
            </el-row>

            <!--      注意事项          -->
            <el-row class="info-panel"
              style="background-color: #FFFFFF;box-shadow: 2px 2px 5px #ECECEC;min-height: 380px;">
              <div class="panel-title" style="margin-top: 10px">{{ $t('booking.attentions') }}</div>
              <div class="tip_item">
                <div>
                  <i class="el-icon-warning" style="color: #3b82f6;font-size: 14px"/>
                </div>
                <div style="color: #545c6a;font-size: 14px;">
                  <span>{{ $t('booking.Booking_prompt') }}:</span>
                  {{ $t('booking.info_confirm') }}
                  {{ $t('booking.info_price') }}
                  {{ $t('booking.info_get') }}
                </div>
              </div>
              <div class="tip_item">
                <div>
                  <i class="iconfont icon-bianji" style="color: #7d838f;font-size: 12px"/>
                </div>
                <div style="color: #545c6a;font-size: 14px;">
                  <span>{{ $t('booking.Change_or_cancel') }}:</span>
                  {{ $t('booking.change_info') }}
                </div>
              </div>
              <div class="tip_item">
                <div>
                  <i class="iconfont icon-B1BECF" style="color: #7d838f"/>
                </div>
                <div style="color: #545c6a;font-size: 14px;">
                  <span>{{ $t('booking.Not_arriving_or_late') }}:</span>
                  {{ $t('booking.late_info') }}
                </div>
              </div>
              <div class="tip_item" v-if="specialCharges">
                <div>
                  <i class="iconfont icon-shuifei" style="color: #7d838f"/>
                </div>
                <div style="color: #545c6a;font-size: 14px;">
                  <span>税费说明:</span>
                  请注意，您在预订海外酒店时，除了房价外，还可能产生税费（城市税、增值税等）及其他附加费，这些费用将由酒店或当地政府根据相关规定收取，并可能在您入住时直接收取或在预订时由我们代收。如有疑问，请联系客服。
                </div>
              </div>
            </el-row>
            <span class="super-text" @click="$router.go(-1)"><{{ hotelInfo.nameCn }}({{ hotelInfo.nameEn }})</span>
          </el-col>
          <!--   右边   -->
          <el-col :span="8">
            <el-row class="info-panel" style="margin: 10px; padding: 0;">
             <div>
               <el-image style="width: 100%;height: 140px;border-radius: 8px 8px 0 0 !important;" fit="cover"
                         :src="hotelInfo.hotelImages && hotelInfo.hotelImages[0] ? hotelInfo.hotelImages[0] : require('@/assets/img/no-img.jpg')">
               </el-image>
               <div style="font-size: 16px;font-weight: 600;padding: 10px">
                 <div style="display: flex;flex-wrap: wrap">
                   <div>
                     <div>{{ hotelInfo.nameCn }}</div>
                     <div style="font-size: 12px;font-weight: normal;margin-top: 10px;">({{ hotelInfo.nameEn }})</div>
                   </div>
                 </div>
                 <div style="margin-top: 8px">
                   <div class="hotel_star" v-if="hotelInfo.star">
                     <el-rate v-model="hotelInfo.star" disabled></el-rate>
                   </div>
                   <div class="hotel_star" v-if="!hotelInfo.star && hotelInfo.category">
                     <el-rate v-model="hotelInfo.category" disabled disabled-void-icon-class="iconfont icon-zuanshi"
                              :icon-classes="['iconfont icon-zuanshi', 'iconfont icon-zuanshi', 'iconfont icon-zuanshi', 'iconfont icon-zuanshi', 'iconfont icon-zuanshi']"></el-rate>
                   </div>
                 </div>
                 <div style="margin-top: 10px;">
                   <i class="iconfont icon-didian1" style="color: #333333 !important;"/>
                   <span style="margin-left: 2px;font-size: 12px;color: #333333;font-weight: normal">{{ $commonUtil.getCnStr(hotelInfo.addressCn, hotelInfo.addressEn) }}</span>
                 </div>
               </div>
             </div>
              <div style="padding: 10px">
                <span style="background-color: #f3f4f6;padding: 4px 14px;border-radius: 4px">{{ $commonUtil.getCategoryDesc(hotelInfo.category) }}</span>
                <span style="color: #349357;font-size: 12px;padding: 4px 14px;border-radius: 4px;margin-left: 10px;background-color: #dcfce7">
                  {{ $commonUtil.getScoreDesc(hotelInfo.score) }}
                </span>
              </div>
              <div style="margin-top: 15px;min-height: 80px;padding: 0 10px;">
                <div style="font-weight: 600;font-size: 14px;">{{ $commonUtil.getCnStr(hotelInfo.roomNameCn, hotelInfo.nameEn) }}</div>
                <div style="margin-top: 18px;">
                  <span style="background-color: #ffedd5;color: #d88055;padding: 4px 14px">
                    {{ hotelInfo.mealCount ? `含${hotelInfo.mealCount}份早餐` : '不含早餐' }}
                  </span>
                </div>
                <div style="margin-top: 18px;color: #666b70;display: flex;column-gap: 8px">
                  <span>
                    <i class="iconfont icon-a-qietu1" style="font-size: 12px"/>
                    {{ hotelInfo.bedInfo }}
                  </span>
                  <span v-if="roomInfo.area">
                    <i class="iconfont icon-a-qietu2" style="font-size: 12px"/>
                    {{ roomInfo.area }}m²
                  </span>
                  <span v-if="(roomInfo.windowType === 0 || roomInfo.windowType)">
                    <i class="iconfont icon-a-qietu5" style="font-size: 12px"/>
                    {{ windowTypeMap[roomInfo.windowType] }}
                  </span>
                  <span v-if="roomInfo.floor">
                    <i class="iconfont icon-louceng" style="font-size: 12px"/>
                    {{ roomInfo.floor }}
                  </span>
                  <span v-if="roomInfo.maxOccupancy">
                    <i class="iconfont icon-a-qietu3" style="font-size: 12px"/>
                    最多{{ roomInfo.maxOccupancy }}人
                  </span>
                </div>
                <div style="font-size: 14px;padding: 10px 0;">
                  <span v-if="rateInfo.rates">
                    <i class="el-icon-circle-check" style="color: #82bf23"
                       v-if="isCancelOrder(rateInfo.rates[0].freeCancelTime, rateInfo.showCancelTime) !== '不可取消'"/>
                    <i class="el-icon-circle-close" style="color: #ff100c" v-else/>
                    <span style="font-size: 12px"
                      :style="isCancelOrder(rateInfo.rates[0].freeCancelTime, rateInfo.showCancelTime) !== '不可取消' ? 'color: #82bf23;' : 'color: red;'">
                      {{ isCancelOrder(rateInfo.rates[0].freeCancelTime, rateInfo.showCancelTime) }}
                    </span>
                  </span>
                </div>
              </div>
            </el-row>

            <el-row class="info-panel" style="padding: 20px 0 0 0;background-color: #FFFFFF;margin-top: 10px;">
              <div class="panel-title"
                style="padding-bottom: 5px;margin-left: 20px;margin-right: 10px;">
                {{ $t('booking.Expense_details') }}
              </div>

              <div v-if="checkRateReq.rooms && rateInfo.rates">
                <div>
                  <div
                    style="margin-top: 10px;display: flex;align-items: center;justify-content: space-between;color: #000000;">
                    <p style="margin-left: 20px;font-size: 14px;">
                      {{ $t('booking.The_room_rate') }}
                      <span v-if="specialCharges || (rateInfo.propertyFees || (rateInfo.localCurrency && rateInfo.localPropertyFees))">
                        (含税/费)
                      </span>
                    </p>
                    <p style="margin-right: 20px; font-size: 14px">
                      {{ rateInfo.rates.length }}晚,{{ checkRateReq.rooms }}间&nbsp;&nbsp;共￥{{ rateInfo.net }}
                    </p>
                  </div>
                  <div class="costDetail" v-for="(itme, index) in this.rateInfo.rates" :key="index">
                    <p style="margin-left: 35px;font-size: 16px;">{{ itme.date }}</p>
                    <p style="margin-right: 20px;font-size: 16px;">
                      <span>￥{{ itme.value }}</span>
                      <span v-if="checkRateReq.rooms > 1"> x {{ checkRateReq.rooms }}</span>
                    </p>
                  </div>
                  <div class="costDetail" style="padding: 40px 20px 10px 20px" v-if="specialCharges">
                    <div style="font-size: 14px;color: #000">税费和服务费</div>
                    <div style="font-size: 14px;">
                      共￥{{ (specialCharges * checkRateReq.rooms).toFixed(2) }}
                    </div>
                  </div>
                  <div class="costDetail" style="padding: 40px 20px 10px 20px"
                       v-if="rateInfo.propertyFees || (rateInfo.localCurrency && rateInfo.localPropertyFees)">
                    <div style="font-size: 14px;color: #000">到店另付税/费</div>
                    <div style="font-size: 14px;">
                      <p style="text-align: right" v-if="rateInfo.propertyFees">{{ rateInfo.propertyFees }}(CNY)</p>
                      <p style="text-align: right" v-if="rateInfo.localCurrency && rateInfo.localPropertyFees">
                        {{ rateInfo.localPropertyFees }}({{ rateInfo.localCurrency }})
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <!--     底部合计      -->
              <div
                style="background-color: #FFFFFF; color: #fff;padding-top: 25px;padding-bottom:25px; padding-left:0;border-top: dashed 1px #D8D7B9;margin-left: 22px;margin-right: 10px;margin-top: 20px;">
                <div style="color: #debd31; font-size: 16px;">
                  <span style="color: #000000;font-size: 14px;font-weight: 600">订单总金额</span>
                  <span style="float: right; font-weight: 600;color: #1e50f0;">
                    ￥{{ rateInfo.net }}
                  </span>
                </div>
              </div>
            </el-row>

            <el-row class="info-panel" style="background-color: #ffffff">
              <div class="panel-title">{{ $t('booking.Payment_information') }}</div>
              <div style="margin-top: 20px; color: #7b7b7b">
                {{ $t('booking.Total_payables') }}：
                <span style="font-size: 16px; color: #1e50f0; font-weight: 600">
                  {{ rateInfo.net }}{{ $t('booking.yuan') }}
                </span>
              </div>
              <div style="margin-top: 20px;margin-bottom: 20px">
                <el-checkbox v-model="isRead"></el-checkbox>
                <span style="color: #7b7b7b">
                  <span style="cursor: pointer" @click="isRead = !isRead">
                    {{ $t('booking.read') }}
                  </span>
                  <span class="super-text" @click="isShowClause = true">
                    {{ $t('booking.Reservation_terms') }} </span>
                </span>
              </div>
              <div style="display: flex;align-items: center;justify-content: space-between">
                <el-button
                  style="width: 100%;background-color: #1e50f0;color: #ffffff;border: 0 solid #ffffff;font-size: 16px;height: 48px;float: left;"
                  @click="submit" :disabled="!isRead || existOrder">
                  {{ $t('booking.Next_pay') }}
                </el-button>
              </div>
            </el-row>

          </el-col>
        </el-row>

        <div class="retrun-dialog">
          <el-dialog :visible.sync="isShowReturn" :show-close="false" :center="true" :close-on-click-modal="false"
            :close-on-press-escape="false" width="500px">
            <div style="text-align: center; font-size: 18px">
              <div>{{ orderErrorInfo }}</div>
              <div class="btn-normal">
                <el-button type="primary" @click="toHotelList" style="margin-top: 30px; width: 100%">
                  确定
                </el-button>
              </div>
            </div>
          </el-dialog>

          <el-dialog :visible.sync="isShowContinue" :show-close="false" :center="true" :close-on-click-modal="false"
            :close-on-press-escape="false" width="500px">
            <div style="font-size: 18px; line-height: 25px">
              <div>酒店价格发生变化，涨价{{ upPrice }}元，是否继续预订？</div>
              <div style="text-align: center; margin-top: 30px">
                <el-button @click="toHotelList" style="width: 200px">
                  返回
                </el-button>
                <el-button type="warning" @click="onBooking" style="width: 200px">
                  继续预订
                </el-button>
              </div>
            </div>
          </el-dialog>

          <!--     联系人     -->
          <el-dialog :visible.sync="isShowContactSelect" width="520px">
            <el-table :data="contactList" max-height="250" style="margin-top: 10px" @row-click="handleContackClick">
              <el-table-column prop="contactName" label="姓名" width="150">
              </el-table-column>
              <el-table-column prop="contactEmail" label="邮箱" width="150">
              </el-table-column>
              <el-table-column prop="contactPhone" label="电话" width="150">
              </el-table-column>
            </el-table>
          </el-dialog>

          <!--     预订条款     -->
          <clause-dialog :isShow="isShowClause" @closeDialog="isShowClause = false"></clause-dialog>
        </div>

      </div>
      <!--   底部   -->
      <div style="width: 100%;position: absolute;bottom: 0;background-color: #fff;">
        <ContantUs></ContantUs>
        <footerInfo />
      </div>
    </div>
  </div>
</template>

<script>
import foldPanel from './components/FoldPanel.vue'
import foldPanelNot from './components/FoldPanelNot.vue'
import ClauseDialog from '../../frame/components/ClauseDialog.vue'

import HomeHeader from './components/HomeHeader.vue';
import ContantUs from './components/ContantUs.vue';
import footerInfo from '../frame/footerInfo.vue';

export default {
  data () {
    return {
      checkRateReq: {},
      rateInfo: {},
      hotelInfo: {},
      roomInfo: {},
      countdownTime: 20 * 60,
      countdownMinute: 0,
      countdownSecond: 0,
      bookingForm: {
        guestNames: [
          { name: '', firstName: '', lastName: '', roompos: 1 },
          { name: '', firstName: '', lastName: '', roompos: 1 },
          { name: '', firstName: '', lastName: '', roompos: 1 },
          { name: '', firstName: '', lastName: '', roompos: 1 }
        ],
        contactPhoneRegion: '+86',
        contactName: '',
        contactPhone: '',
        contactEmail: ''
      },
      phoneRegions: this.$finalData.PhoneRegions,
      isRead: false,
      bookingReq: {},
      searchForm: {},
      isShowReturn: false,
      isShowContinue: false,
      isShowClause: false,
      upPrice: 0,
      orderErrorInfo: '',
      contactList: [],
      isShowContactSelect: false,
      weekArray: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      canCancelText: '',
      checkRatePass: true,
      singleRoomNet: 0,
      showBtnDialogPartners: [1000],
      scoreTextMap: {
        '5.0': '超级棒',
        '5': '超级棒',
        '4.9': '非常棒',
        '4.8': '棒',
        '4.7': '很好',
        '4.6': '好',
        '4.5': '不错'
      },
      windowTypeMap: {
        0: '无窗',
        1: '有窗',
        2: '部分有窗',
        3: '暗窗',
        5: '封闭窗',
        4: '窗型未知'
      },
      existOrder: false
    }
  },
  components: {
    foldPanel,
    foldPanelNot,
    ClauseDialog,
    HomeHeader,
    ContantUs,
    footerInfo
  },
  computed: {
    specialCharges () {
      let total = 0
      if (this.rateInfo && this.rateInfo.rates && this.rateInfo.rates.length) {
        this.rateInfo.rates.forEach(item => {
          if (item.dailyTaxesAndFees) {
            total += Number(item.dailyTaxesAndFees)
          }
          if (item.dailySalesTax) {
            total += Number(item.dailySalesTax)
          }
        })
      }
      return total
    },
    showRoomGuest() {
      let res = []
      this.bookingForm.guestNames.forEach((item, index) => {
        if (index !== 0 && this.checkRateReq.adults >= index + 1) {
          this.$set(item, 'show', true)
        }
        if (res[item.roompos - 1]) {
          res[item.roompos - 1].push(item)
        } else {
          res[item.roompos - 1] = [item]
        }
      })
      return res
    }
  },
  mounted () {
    this.init()
    this.$commonUtil.modfiyicon()
  },
  methods: {
    getDay (data) {
      return this.weekArray[new Date(data).getDay()]
    },
    init () {
      if (this.$commonUtil.isObjNull(this.$route['params'])) {
        this.$router.push('/NewHome')
      }
      this.checkRateReq = this.$route['params']['checkRateReq']
      this.rateInfo = this.$route['params']['rateInfo']
      this.singleRoomNet = Number(this.rateInfo.net / this.checkRateReq.rooms).toFixed(2)
      this.hotelInfo = this.$route['params']['hotelInfo']
      this.roomInfo = this.$route['params']['room']
      this.searchForm = this.$route['params']['searchForm']
      this.checkRatePass = true
      if (this.searchForm && this.searchForm.room) {
        for (let i = 1; i < this.searchForm.room; i++) {
          this.bookingForm.guestNames.push({ name: '', firstName: '', lastName: '', roompos: (i + 1), show: false })
          this.bookingForm.guestNames.push({ name: '', firstName: '', lastName: '', roompos: (i + 1), show: this.checkRateReq.adults >= 2 })
          this.bookingForm.guestNames.push({ name: '', firstName: '', lastName: '', roompos: (i + 1), show: this.checkRateReq.adults >= 3 })
          this.bookingForm.guestNames.push({ name: '', firstName: '', lastName: '', roompos: (i + 1), show: this.checkRateReq.adults >= 4 })
        }
      }
      this.countdown()
      // 获取联系人信息
      let partnerCode = JSON.parse(localStorage.getItem('partnerInfo')).partnerCode
      let bookingHeader = {
        accessToken: JSON.parse(localStorage.getItem('partnerInfo')).token
      }
      // 自动生成订单号
      this.createOrderNum()
      let vm = this
      vm.$http.get(`/b2b/getB2BContactInfo?partnerCode=${partnerCode}`, {headers: bookingHeader}).then(resp => {
        let result = resp.body
        if (result.success) {
          vm.contactList = result.data
          if (vm.contactList.length > 0) {
            vm.bookingForm.contactName = vm.contactList[0].contactName
            vm.bookingForm.contactPhone = vm.contactList[0].contactPhone
            vm.bookingForm.contactEmail = vm.contactList[0].contactEmail
          }
        }
      }).catch(resp => {
        vm.$message.error('Error：' + resp.status + ' - ' + resp.statusText)
      }).finally(() => {
      })
    },
    async createOrderNum () {
      await this.generateOrderNum()
    },
    async generateOrderNum () {
      let reqHeader = {
        accessToken: JSON.parse(localStorage.getItem('partnerInfo')).token
      }
      const {data: result} = await this.$http.get('/mini/createNewChannelOrderNum', {headers: reqHeader})
      if (result.code !== 200) return this.$message.error(result.message)
      this.$set(this.bookingForm, 'clientReference', `H${result.data}`)
    },
    reCheckRate () {
      if (this.checkRateReq && this.checkRateReq.rooms) {
        this.bookingForm.guestNames = [
          { name: '', firstName: '', lastName: '', roompos: 1, show: false },
          { name: '', firstName: '', lastName: '', roompos: 1, show: this.checkRateReq.adults >= 2 },
          { name: '', firstName: '', lastName: '', roompos: 1, show: this.checkRateReq.adults >= 3 },
          { name: '', firstName: '', lastName: '', roompos: 1, show: this.checkRateReq.adults >= 4 }
        ]
        for (let i = 1; i < this.checkRateReq.rooms; i++) {
          this.bookingForm.guestNames.push({ name: '', firstName: '', lastName: '', roompos: (i + 1), show: false })
          this.bookingForm.guestNames.push({ name: '', firstName: '', lastName: '', roompos: (i + 1), show: this.checkRateReq.adults >= 2 })
          this.bookingForm.guestNames.push({ name: '', firstName: '', lastName: '', roompos: (i + 1), show: this.checkRateReq.adults >= 3 })
          this.bookingForm.guestNames.push({ name: '', firstName: '', lastName: '', roompos: (i + 1), show: this.checkRateReq.adults >= 4 })
        }
      }
      this.checkRateAgain()
    },
    async checkRateAgain (toOrder) {
      let loading = this.$loading({
        text: '努力加载中，请稍后.....',
        spinner: 'el-icon-loading',
        background: this.$finalData.LoadingBgColorAll
      })
      let checkRateHeader = {
        accessToken: JSON.parse(localStorage.getItem('partnerInfo')).token
      }
      this.checkRateReq['totalNet'] = this.singleRoomNet * this.checkRateReq.rooms
      const {data: result} = await this.$http.post('mini/checkRate', this.checkRateReq, { headers: checkRateHeader })
      loading.close()
      if (result.code !== 200 || !result.data.net) {
        this.checkRatePass = false
        this.$message.error(result.message)
        return
      }
      this.upPrice = Number(result.data.net - this.checkRateReq.totalNet).toFixed(2)
      if (!toOrder && this.upPrice > 0) {
        this.$confirm(`酒店价格发生变化，涨价${this.upPrice}元`, '涨价提醒', {
          type: 'warning'
        })
      }
      this.rateInfo = result.data
      this.checkRatePass = true
    },
    async submit () {
      if (!this.checkRatePass) {
        this.$confirm('无法为您提供当前条件下的房间数报价，请修改入住人或房间数', '温馨提示', {
          showClose: false,
          type: 'warning'
        })
        return
      }
      if (!this.bookingForm.contactEmail || !this.bookingForm.contactName || !this.bookingForm.contactPhone || !this.bookingForm.contactPhoneRegion || !this.bookingForm.clientReference) {
        this.$message.warning('请填写完整信息！')
        return
      }
      for (let i = 0; i < this.bookingForm.guestNames.length; i++) {
        let index = this.bookingForm.guestNames.findIndex(g => g.roompos === i + 1)
        if (index !== -1) {
          if (!this.bookingForm.guestNames[index].firstName || !this.bookingForm.guestNames[index].lastName) {
            this.$message.warning('请填写完整信息！')
            return
          }
        }
        if ((this.bookingForm.guestNames[i].firstName && !this.bookingForm.guestNames[i].lastName) ||
          (!this.bookingForm.guestNames[i].firstName && this.bookingForm.guestNames[i].lastName)) {
          this.$message.warning('请填写完整信息！')
          return
        }
      }
      if (!this.$commonUtil.isEmailAvailable(this.bookingForm.contactEmail)) {
        this.$message.warning('请输入正确邮箱！')
        return
      }
      let inputOrderIdTest = /^[a-zA-Z0-9\/_-]{1,30}$/
      if (!inputOrderIdTest.test(this.bookingForm.clientReference)) {
        this.$message.warning('请输入正确企业订单号！')
        return
      }
      if (!this.isRead) {
        this.$message.warning('请阅读出行提示和费用说明！')
        return
      }
      await this.checkRateAgain(true)
      this.bookingReq = {
        contactPhone: this.bookingForm.contactPhone,
        contactName: this.bookingForm.contactName,
        contactEmail: this.bookingForm.contactEmail,
        inputGuests: this.bookingForm.guestNames,
        guestNames: this.bookingForm.guestNames,
        clientReference: this.bookingForm.clientReference,
        rateKey: this.rateInfo.rateKey,
        supplierId: this.rateInfo.supplierId,
        rates: this.rateInfo.rates,
        fromWhere: 'website',
        adults: this.checkRateReq.adults
      }
      let nameArr = []
      this.bookingReq.guestNames.forEach(item => {
        if (item.lastName && item.firstName) {
          let fullName = item.lastName + item.firstName
          nameArr.push(fullName)
        }
      })
      this.bookingReq.guestNames = nameArr
      if (this.upPrice > 0) {
        this.orderErrorInfo = '无房或满房，请重新预订。'
        this.isShowContinue = true
      } else {
        this.upPrice = 0
        this.onBooking()
      }
    },
    async savePayInfo(outerId, payInfo) {
      let header = {
        accessToken: JSON.parse(localStorage.getItem('partnerInfo')).token,
        outerId
      }
      const {data: result} = await this.$http.post('/mini/savePayInfo', payInfo, {headers: header})
    },
    onBooking () {
      let bookingHeader = {
        accessToken: JSON.parse(localStorage.getItem('partnerInfo')).token
      }
      if (!this.$commonUtil.getRegionIdBySHotelId(this.checkRateReq.hotelId)) {
        this.bookingReq.propertyFees = this.rateInfo.propertyFees
        this.bookingReq.localPropertyFees= this.rateInfo.localPropertyFees
        this.bookingReq.localCurrency= this.rateInfo.localCurrency
      }
      let vm = this
      vm.$http.post('/mini/booking', vm.bookingReq, { headers: bookingHeader }).then(async (resp) => {
        let result = resp.data
        if (result.code == 200) {
          let res = {
            priRoomtype: vm.hotelInfo.roomNameCn,
            priRoomtypeEn: vm.hotelInfo.roomNameEn,
            priBedtype: vm.hotelInfo.bedInfo,
            canCancel: vm.canCancelText,
            b2bCancel: vm.rateInfo.showCancelTime,
            guestName: vm.bookingReq.guestNames,
            checkIn: vm.checkRateReq.checkIn,
            checkOut: vm.checkRateReq.checkOut,
            hotelName: `${vm.hotelInfo.nameCn}-${vm.hotelInfo.nameEn}`,
            payAmount: vm.rateInfo.net,
            outerOrderId: result.data
          }
          // localStorage.setItem(`bookingOrderInfo-${result.data}`, JSON.stringify(res))
          // localStorage.setItem(`bookingSearchForm-${result.data}`, JSON.stringify(vm.searchForm))
          // localStorage.setItem(`bookingRates-${result.data}`, JSON.stringify(vm.rateInfo.rates))
          let payInfo = {
            bookingOrderInfo: res,
            bookingSearchForm: vm.searchForm,
            bookingRates: vm.rateInfo.rates
          }
          await vm.savePayInfo(result.data, payInfo)
          await vm.$router.push({
            path: '/cashier',
            query: {
              outerId: result.data
            }
          })
        } else {
          vm.$message.error('请求失败，请稍后再试。')
        }
      }).catch(resp => {
        console.log(resp)
        vm.$message.error('Error：' + resp.status + ' - ' + resp.statusText)
      }).finally(() => {
      })
    },
    countdown () {
      if (this.countdownTime >= 0) {
        this.countdownMinute = Math.floor(this.countdownTime / 60)
        this.countdownSecond = Math.floor(this.countdownTime % 60)
        this.countdownTime--
        let vm = this
        window.setTimeout(() => {
          vm.countdown()
        }, 1000)
      }
    },
    toHotelList () {
      this.$commonUtil.localStorageSetItem('bookingSearchForm', this.searchForm)
      this.$router.go(-1);
    },
    handleContackClick (row) {
      this.bookingForm.contactName = row.contactName
      this.bookingForm.contactPhone = row.contactPhone
      this.bookingForm.contactEmail = row.contactEmail
      this.isShowContactSelect = false
    },
    isNameCorrect (name) {
      let zwReg = /[\u4E00-\u9FFF]+/ // 最少含有一个中文
      if (name && !zwReg.test(name)) {// 一个中文都没有
        if (name.indexOf('/') != -1) {
          return true
        } else {
          return false
        }
      }
      return true
    },
    canCancel (cancellationPolicies) {
      if (cancellationPolicies && cancellationPolicies[0] && cancellationPolicies[0].from) {
        let jsTime = Date.parse(cancellationPolicies[0].from)
        if (jsTime > new Date().getTime()) {
          return true
        }
      }
      return false
    },
    isCancelOrder (time, showCancelTime) {
      let hotelCancelTime = new Date(time).getTime();
      let today = new Date().getTime();
      if (typeof hotelCancelTime == 'number') {
        if (hotelCancelTime > today) {
          this.canCancelText = 'yes'
          return `${showCancelTime} ${this.$t('hotel_detail.Free_cancellation_before')}`
        }
      }
      this.canCancelText = 'no'
      return this.$t('hotel_detail.no_cancel')
    },
    guestChange (g, e, guest, index) {
      if (!e) {
        this.$set(guest, 'lastName', '')
        this.$set(guest, 'firstName', '')
        this.$set(g[index], 'show', e)
      } else {
        this.$set(g[index + 1], 'show', e)
      }
    },
    showGuest (g, guest, index, type) {
      let showCount = g.filter(t => t.show).length
      if (!showCount && index === 0) {
        if (showCount < this.checkRateReq.adults - 1) {
          return type === 1
        } else {
          return false
        }
      } else {
        let lastIndex = g.findLastIndex(t => t.show)
        if (lastIndex === index) {
          if (type === 2) {
            return true
          }
          return showCount < this.checkRateReq.adults - 1
        }
      }
    },
    inputChannelOrderNum (e) {
      if (!e) return
      let headers = {
        accessToken: JSON.parse(localStorage.getItem('partnerInfo')).token
      }
      this.$common.debounce(async () => {
        const {data: result} = await this.$http.get(`/mini/checkChlOrderNumExist?chlOrderNum=${e}`, {headers})
        this.existOrder = result.code === 200
      }, 300)
    }
  }
}
</script>

<style scoped>
.max {
  font-family: '苹方' !important;
}
.info-panel {
  background-color: #FFFFFF;
  margin: 10px;
  padding: 20px;
  border-radius: 8px;
}

.tip_item {
  margin-top: 25px;
  line-height: 30px;
  margin-left: 10px;
  background-color: #f9fafb;
  padding: 10px;
  border-radius: 12px;
  display: flex;
  column-gap: 8px;
}

.panel-title {
  font-size: 16px;
  font-weight: bolder;
  font-family: '苹方', serif;
}

.click-text {
  text-decoration: underline;
  color: #144199;
  cursor: pointer;
}

.super-text {
  color: #144199;
  cursor: pointer;
  margin-left: 0;
}

.booking-form-title {
  text-align: left;
  line-height: 30px;
  padding-left: 20px;
}

.reserve-info-row {
  font-size: 14px;
  padding: 8px 0 8px 0;
}

.reserve-info-title {
  text-align: center;
  color: #999999;
}

>>>.el-input__icon {
  line-height: 30px;
}

>>>.el-input__inner {
  height: 35px !important;
  line-height: 35px;
}

>>>.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #7b7b7b;
}

.retrun-dialog>>>.el-dialog {
  border-radius: 7px;
}

.retrun-dialog>>>.el-dialog__header {
  height: 0;
  padding: 0;
}

.retrun-dialog>>>.el-dialog__body {
  padding: 35px;
}

>>>.el-table__row {
  cursor: pointer;
}

.costDetail {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
  align-items: end;
  color: #7F7F7D;
  position: relative;
  height: 30px;
}

.isReadPay {
  background-color: #999999;
}

.clientReference>>>.el-input__inner {
  height: 42px;
  font-size: 16px;
}

.lastName>>>.el-input__inner,
.firstName>>>.el-input__inner {
  height: 42px;
  font-size: 16px;
}

.contactName>>>.el-input__inner {
  height: 42px;
  font-size: 16px;
}

>>>.el-icon-circle-plus-outline:before {
  width: 16px;
  height: 16px;
  font-size: 16px;
}
</style>

<style scoped lang="stylus">
.room_adults_box {
  font-size: 14px;

  & >>> .el-select .el-input {
    min-width: auto !important;
    width: auto !important;
  }

  //& >>> .el-input__inner {
  //  border: none;
  //  background: #fff;
  //  color: #1e50f1;
  //  font-weight: bolder;
  //  width: 100%;
  //  overflow: hidden;
  //  text-overflow: ellipsis;
  //  display: -webkit-box;
  //  -webkit-line-clamp: 1;
  //  -webkit-box-orient: vertical;
  //
  //  &::placeholder {
  //    color: #1e50f1;
  //    font-weight: bolder;
  //  }
  //}
  //
  //& >>> .el-input__inner:focus {
  //  border: none !important;
  //  box-shadow: none !important;
  //}
  //
  //& >>> .el-input__suffix {
  //  & .el-select__caret.el-input__icon {
  //    color: #1e50f1 !important;
  //    font-weight: bolder;
  //  }
  //}
}

.step_box {
  margin: 10px 10px 0 10px;
  padding: 20px;
  display: flex;
  align-items: center;
  column-gap: 60px;
  border-radius: 8px;
  justify-content: center;

  .step_item {
    font-size: 13px;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 8px;

    .num {
      //background-color: #aaaaaa;
      border: 1px solid #d0d7de;
      width: 32px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      border-radius: 50px;
      font-weight: bold;

      i {
        position: relative;
        top: -2px;
      }

      &.active {
        color: #FFFFFF;
        background-color: #1e50f0;
        border: none;
      }
    }
  }
}

.count_down_box {
  margin: 10px 10px 15px 10px;
  padding: 20px;
  background-color: #fde9e0;
  border-radius: 8px;
  box-shadow: 2px 2px 5px #ECECEC;

  color: #f67939;
  font-size: 14px;
  font-weight: bold;
}

.guest_box {
  border-radius: 8px;
  margin-bottom: 15px;
}

.content_box >>> .el-row {
  margin-top: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/booking/BookingDetail.vue